module.exports = __webpack_public_path__ + "static/media/home-music.af350416.mp3";